// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleBillingManager = {
  id: "billing-manager",
  mrn: "//iam.api.mondoo.app/roles/billing-manager",
  title: "Billing Manager",
  allowedActions,
} as const;

export type RoleBillingManager = typeof roleBillingManager;
